import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentSpecificService } from '../../../../environment-specific.service';
import { Http } from '../../http-client/http-client.component';
import { Observable } from 'rxjs';
import { ApiSocket } from '../../../../app.module';

declare var $:any;

@Injectable()
export class FileUploadService {

    apiUrl:any;
    developmentEnv:boolean = true;
    
    constructor(
      private http: Http,
      private _http: HttpClient,
      private _apiSocket: ApiSocket,
      private _envService: EnvironmentSpecificService
    ) {
  
      this.apiUrl = this._envService.envSpecific.apiUrl;
      this.developmentEnv = this._envService.envSpecific.developmentEnv;
      this.ConnectWebSocket();
    }

    ConnectWebSocket() {
      this._apiSocket.connect();
    }
  
    DisconnectWebSocket() {
      if(this._apiSocket) {
        this._apiSocket.ioSocket.removeListener();
      }
      this._apiSocket.disconnect();
      this._apiSocket = null;
    }

    clientUploadTrigger = () => {
      console.log("clientUploadTrigger");
      return Observable.create((observer) => {
       
        if (this._apiSocket.ioSocket._callbacks != null && this._apiSocket.ioSocket._callbacks['$connect'])  this._apiSocket.removeListener('connect');
        this._apiSocket.on("connect", () => {
            console.log("Websocket User connected");
        });

        if (this._apiSocket.ioSocket._callbacks != null && this._apiSocket.ioSocket._callbacks['$clientuploadtrigger'])  this._apiSocket.removeListener('clientuploadtrigger');
          this._apiSocket.on('clientuploadtrigger', (message) => {
            observer.next({type:'clientuploadtrigger', response:message});
          });
        });
    }

    uploadPercentage(message){
      var multiFilePercentage = ( message.response.byteWritten / message.response.totalAllFileSize) * 100;
      
      if($('#waiting-upload-div-inputprogress').val() > multiFilePercentage) {
          return;
      }

      if (multiFilePercentage <= 99) {
          $('#waiting-upload-div-progress').attr('aria-valuenow', multiFilePercentage.toFixed(0)).css('width', multiFilePercentage.toFixed(0)+'%');
          $('#waiting-upload-div-spanprogress').html(multiFilePercentage.toFixed(0) + ' %');
          $('#waiting-upload-div-inputprogress').val(multiFilePercentage.toFixed(0));
      }else{
          $('#waiting-upload-div-progress').attr('aria-valuenow',99).css('width','99%');
          $('#waiting-upload-div-spanprogress').html('99 %');
          $('#waiting-upload-div-inputprogress').val(99); 
          setTimeout(() => {
              $('#waiting-upload-div-progress').attr('aria-valuenow', 100).css('width','100%');
              $('#waiting-upload-div-spanprogress').html('100 %');
              $('#waiting-upload-div-inputprogress').val(100); 
          }, 1000);
      }
    }

    upload(files,totalFilesSize,folderId): Observable<any> {
      let params = "";
      if(folderId!=null){
          params = "?folderid="+folderId;
      }

      var option = {
          headers:new HttpHeaders().set('x-total-file-size',  totalFilesSize.toString())
      }
      return this.http.post(this.apiUrl + `/files/uploads${params}`,files,option).map((response: Response) => {
        return response;
      });
    }

    onUploadDone() {

      $('#waiting-upload-div-progress').attr('aria-valuenow', 99).css('width', 99+'%');
      $('#waiting-upload-div-spanprogress').html(99 + ' %');
      $('#waiting-upload-div-inputprogress').val(99);
      
      setTimeout(() => {
        $('#waiting-upload-div-progress').attr('aria-valuenow', 100).css('width', 100+'%');
        $('#waiting-upload-div-spanprogress').html(100 + ' %');
        $('#waiting-upload-div-inputprogress').val(100);
      }, 1000);

    }
}